import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import config from 'config'
import cartActions from 'redux/actions/cartActions'
import generalActions from 'redux/actions/generalActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'
import { cartSelectors } from 'redux/selectors'

function goToCart() {
	window.open(config.app+'checkout', '_self')
}

const CONFIRM_TYPE = confirmTypes.CART_ITEM_ADDED

const CartAddedConfirm = props => (<Confirm
	btOne={localize('global_ok')}
	btTwo={localize('global_checkout')}
	alertTitle={props.name}
	alertMessage={localize('private_library_cart_itemAdded')}
	actionButtonType={0}
	actionOne={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	actionTwo={
		() => {
			goToCart()
		}
	}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)} />)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		gotoCart: cartActions.gotoCart,
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

function makeMapStateToProps() {
	const mapStateToProps = (state, props) => cartSelectors.cartGotoCheckoutSelector(state, props)
	return mapStateToProps
}

export default connect(makeMapStateToProps, mapDispatchToProps)(CartAddedConfirm)
